/**
 * Application logger utility
 * Provides environment-aware logging that only outputs in development
 */

const isDevelopment = import.meta.env.DEV;

export const logger = {
  /**
   * Log general information (development only)
   */
  log: (...args: any[]) => {
    if (isDevelopment) {
      console.log(...args);
    }
  },

  /**
   * Log debug information (development only)
   */
  debug: (...args: any[]) => {
    if (isDevelopment) {
      console.debug(...args);
    }
  },

  /**
   * Log warnings (always shown)
   */
  warn: (...args: any[]) => {
    console.warn(...args);
  },

  /**
   * Log errors (always shown)
   */
  error: (...args: any[]) => {
    console.error(...args);
  },

  /**
   * Log API calls (development only)
   */
  api: (method: string, url: string, data?: any) => {
    if (isDevelopment) {
      console.log(`[API ${method}]`, url, data || '');
    }
  },

  /**
   * Log navigation events (development only)
   */
  navigation: (from: string, to: string, state?: any) => {
    if (isDevelopment) {
      console.log(`[Navigation] ${from} → ${to}`, state || '');
    }
  },
};

export default logger;
